import File from './file';

export default {
  init: function (selector) {
    const fileInputs = document.querySelectorAll(selector);

    if (fileInputs && fileInputs.length) {
      [...fileInputs].map(item => {
        const fileInput = new File(item);
        fileInput.init();
      });
    }
  }
};
